import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Unique title + meta description per route (SEO). No external dependency.
const MAP = {
  "/": {
    title: "Trisha Wealth | Free Financial Health Check-Up & Health Score",
    description:
      "Take the free 12-question Financial Health Check-Up from Trisha Wealth. Get your Financial Health Score, discover your top 3 priorities and a personalised improvement plan.",
  },
  "/assessment": {
    title: "Financial Health Assessment | Trisha Wealth Check-Up",
    description:
      "Answer 12 simple questions about protection, savings, investments, goals and retirement to calculate your personalised Financial Health Score.",
  },
  "/calculators": {
    title: "Free Financial Calculators — SIP, Retirement, Goal | Trisha Wealth",
    description:
      "Plan your money with free SIP, Retirement, Goal Planning and Net Worth calculators from Trisha Wealth to close the gaps found in your Financial Health Check-Up.",
  },
  "/privacy": {
    title: "Privacy Policy | Trisha Wealth Financial Health Check-Up",
    description:
      "Read the Trisha Wealth privacy policy: what information we collect during the Financial Health Check-Up, how we use it, how we protect it, and your rights.",
  },
  "/admin/login": {
    title: "Advisor Login | Trisha Wealth",
    description: "Secure advisor login for the Trisha Wealth Financial Health Check-Up dashboard.",
  },
};

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function RouteSEO() {
  const { pathname } = useLocation();
  useEffect(() => {
    let seo = MAP[pathname];
    if (!seo && pathname.startsWith("/result")) {
      seo = {
        title: "Your Financial Health Report | Trisha Wealth",
        description:
          "Your personalised Financial Health Report with your score, strongest areas, gaps and your top 3 financial priorities.",
      };
    }
    if (!seo && pathname.startsWith("/admin")) {
      seo = {
        title: "Advisor Dashboard | Trisha Wealth",
        description: "Secure advisor dashboard for managing Financial Health Check-Up leads and meetings.",
      };
    }
    if (!seo) {
      seo = {
        title: "Page Not Found | Trisha Wealth",
        description: "The page you are looking for could not be found. Explore the Trisha Wealth Financial Health Check-Up.",
      };
    }
    document.title = seo.title;
    setMeta("description", seo.description);
  }, [pathname]);
  return null;
}
